import React, { useState, useEffect, Component, FC, Fragment } from "react";
import ActionButton from "../../../components/Buttons/ActionButton";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/edit.svg";
import UserService from "../../../services/UserService";
import {
  useAction,
  useActions,
  useActionGroups,
  useDevice,
  useDeviceGroup,
  useDeviceGroups,
  useDevices,
  useDeviceType,
  useDeviceTypes,
} from "../../../Api/newSockets.api";
import SearchButton from "../../../components/Buttons/SearchButton";
import { ReactComponent as AddItemIcon } from "../../../assets/icons/add.svg";
import AddButton from "../../../components/Buttons/AddButton";
import Modal from "../../../components/Modals/Modal";
import Input from "../../../components/DataEntry/Input";
import Select from "../../../components/DataEntry/Select";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import Table from "../../../components/Table/Table";
import Search from "../../../components/Search/Search";
import Header from "../../../components/Header/Header";
import { ReactComponent as SettingsIcon } from "../../../assets/icons/settings.svg";
import { ReactComponent as BlockIcon } from "../../../assets/icons/block.svg";
import { ReactComponent as ProgramIcon } from "../../../assets/icons/program.svg";
import Programs from "../Program/Programs";
import Tabs from "../../../components/Tabs/Tabs";
import develop_tab_data from "../../../assets/mockedData/develop_tab_data";
import MultiSelect from "../../../components/DataEntry/MultiSelect";
import { savePathToLocalStorage } from "../../../utils/helpers";

type Props = {};

const Actions: FC<Props> = () => {
  const headers = [
    {
      label: "Name",
      key: "name",
      type: "text",
    },
    {
      label: "Block Library",
      key: "blockLibrary.name",
      type: "text",
    },
    {
      label: "Date Created",
      key: "dateCreated",
      type: "date",
    },
    {
      label: "Date Modified",
      key: "dateModified",
      type: "date",
    },
  ];
  savePathToLocalStorage();
  const { actionGroups } = useActionGroups();
  console.log(actionGroups);
  const { deviceTypes } = useDeviceTypes();
  const { addAction, deleteAction } = useAction();
  const { actions, searchActions, connected } = useActions();
  const history = useHistory();
  const [selectedItems, setSelectedItems] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [name, setName] = useState("");
  const [deviceGroupId, setDeviceGroupId] = useState(null);
  const [actionGroupId, setActionGroupId] = useState(null);
  const [developTabData, setDevelopTabData] = useState(develop_tab_data);
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  const handleNewAction = () => {
    setModalOpen(true);
  };
  console.log(history);

  const handleSubmitAction = () => {
    setLoading(true);
    const data = deviceGroupId?.map((id) => id.id);
    // addAction({
    //   name: name,
    //   dateCreated: new Date(),
    //   actionGroupId: parseInt(actionGroupId),
    //   deviceTypeId: data,
    // }).then((data: any) => {
    //   history.push(`/develop/action/${action.id}`);
    // });
    const action = {
      name: name,
      dateCreated: new Date(),
      actionGroupId: parseInt(actionGroupId),
      deviceTypeId: data,
    };
    console.log(action);

    addAction(action).then((action: any) => {
      history.push(`/develop/action/${action.id}`);
    });
  };

  const handleDeleteAction = (action: any) => {
    deleteAction(action.id);
  };

  const onClose = () => {
    setModalOpen(false);
  };

  const filterActions = (input) => {
    setSearchInput(input);
  };

  useEffect(() => {
    if (!connected) return;
    searchActions(searchInput).catch(() => {});
  }, [connected, searchInput]);

  const actionButtons = () => <>No actions available</>;

  return (
    <div>
      <Header
        title="Actions"
        searchFunction={filterActions}
        // mainAction={
        //   <AddButton
        //     icon={<AddItemIcon />}
        //     label="New action"
        //     onClick={handleNewAction}
        //   />
        // }
      />
      <div className="main-content-flex">
        <Tabs data={developTabData} />
        <div className="section">
          {actions?.map((type: any) => {
            return (
              <Fragment>
                <p className="table-title">{type.name}</p>
                <Table
                  items={type.actions?.filter(
                    (array) => array.actionGroupId == type.id
                  )}
                  headers={headers}
                  to="develop/action"
                  tableName="actions"
                  onDelete={(action: any) => handleDeleteAction(action)}
                  actions={actionButtons}
                />
              </Fragment>
            );
          })}
          {/* <Fragment>
            <p className="table-title">{actionGroups?.name}</p>
            <Table
              items={actionGroups}
              headers={headers}
              to="develop/action"
              onDelete={(action) => handleDeleteAction(action)}
            />
          </Fragment> */}
        </div>

        {/* User input modal */}
        <Modal
          visible={modalOpen}
          onClose={onClose}
          title="Add new action"
          onSubmit={handleSubmitAction}
          submitLoading={loading}
        >
          <Input
            placeholder="Enter a name"
            onChange={(name: any) => setName(name)}
          />
          {/* <Select
            placeholder="Select a device group"
            options={deviceGroups}
            onChange={(name: any) => setDeviceGroupId(name)}
          /> */}
          <Select
            placeholder="Select action group"
            options={actionGroups}
            onChange={(actionName: any) => setActionGroupId(actionName)}
          />
          <MultiSelect
            placeholder="Choose your categories"
            onChange={setDeviceGroupId}
            options={deviceTypes}
          />
        </Modal>
      </div>
    </div>
  );
};

export default Actions;
